import { useLocation } from "react-router-dom";
import { getLangFromPath } from "./routes";

// Current page language ("fr" | "en"), derived from the URL.
const useLang = () => getLangFromPath(useLocation().pathname);

export default useLang;
